import { BaseScopedTaskEventParams } from "@captions-web/dev-logger";

import { createEventDefs } from "../event-def";

export const AudioCreationEvents = createEventDefs<{
  upload_file_status: BaseScopedTaskEventParams & {
    project_id?: string;
  };
  status: BaseScopedTaskEventParams & {
    project_id?: string;
    creation_mode: "upload" | "generate" | "record";
    tts_id?: string;
    asset_id?: string;
    sample_id?: string;
  };
  load_audio_status: {
    status: "finish" | "error";
    audio_duration_ms?: number;
    error_message?: string;
    error_scope?: string;
  };
  tts_generate_status: BaseScopedTaskEventParams & {
    model_id: string;
    voice_id: string;
    text: string;
  };
  voice_settings_open: {
    model_id: string;
    voice_id: string;
  };
  voice_settings_change: {
    previous_model_id: string;
    previous_voice_id: string;
    new_model_id: string;
    new_voice_id: string;
  };
  sample_audio_selected: {
    sample_id: string;
    label: string;
  };
}>({ namespacePrefix: "studio_audio_creation_" });
